<template>
    <div v-if="total">
        <div class="card-header">
            <h6>{{ props.title }}</h6>
            <div>
                <span v-if="props.routeName" class="header-buttons">
                    <router-link :to="{ name: props.routeName }"><i class="pi pi-arrow-up"></i></router-link>
                </span>
                <span v-else class="header-buttons">
                    <i class="pi pi-arrow-up"></i>
                </span>
            </div>
        </div>
        <div class="overview-content">
            <h3>{{ total }}</h3>
            <div class="overview-graph">
                <span v-for="num in arrayOfNumbers" :key="num" :style="'height: ' + num + 'px'">
                    <span class="graph-tooltip">{{ num }}</span>
                </span>
            </div>
        </div>
        <div class="overview-footer">
            <span>
                <i class="pi" :class="changesDetails?.changeType === 'increase' ? 'pi-arrow-up' : 'pi-arrow-down'"></i> <span>{{ changesDetails?.percentage }}%</span> {{ changesDetails?.changeType }} in new {{ props.title.toLocaleLowerCase() }}
            </span>
        </div>
    </div>
    <div v-else class="w-ful h-full flex justify-content-center align-items-center">
        <MoonLoader />
    </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import { generateRandomNumbers, calPercentChange } from '../../../../../utilities';

const props = defineProps({
    title: {
        type: String,
    },
    total: {
        type: Number,
    },
    routeName: {
        type: String,
    },
});

const arrayOfNumbers = ref([]);

watch(
    () => props.total,
    () => {
        if (props.total) {
            arrayOfNumbers.value = generateRandomNumbers(5, props.total);
        }
    },
    {
        immediate: true,
    }
);

const changesDetails = computed(() => {
    const lastTwoNumbers = arrayOfNumbers.value?.slice(-2);
    return calPercentChange(...lastTwoNumbers);
});
</script>
